/**
 * 结算通道展示名（「先选通道、再选支付方式」的第一步，ADM-PAY-S008 策略面板 / ADM-APP-S013 图标面板共用）。
 *
 * 只登记结算通道层（`SETTLEMENT_CHANNELS`）；支付方式的展示名与分组不在这里维护，取 A8 §7.8.8 可选列表的
 * `label` / `group`（`~/data/adapters/payment-method-option-lookup`）。展示名只给运营对齐用，不是 C 端下发内容。
 */

import { type SettlementChannel, isSettlementChannel } from '@novel-admin/shared';

export const SETTLEMENT_CHANNEL_LABEL: Record<SettlementChannel, string> = {
  IAP: '应用内支付 (IAP)',
  STRIPE: 'Stripe',
  PAYERMAX: 'PayerMax',
  AIRWALLEX: 'Airwallex',
};

/**
 * 任意结算通道值 → 展示名：结算通道闭集内的取 `SETTLEMENT_CHANNEL_LABEL`；其余（§7.8.8 下发、admin 结算通道闭集
 * 尚未登记的通道值）退回通道值本身，不在本仓另造展示名。
 */
export function channelDisplayLabel(channel: string): string {
  return isSettlementChannel(channel) ? SETTLEMENT_CHANNEL_LABEL[channel] : channel;
}

/** 图标面板一级分组（按结算通道）标题；admin 结算通道闭集外的通道值退回通道值本身（见 `channelDisplayLabel`）。 */
export const SETTLEMENT_CHANNEL_GROUP_TITLE: Record<SettlementChannel, string> = {
  IAP: '应用内支付',
  STRIPE: '第三方支付 (Stripe)',
  PAYERMAX: '第三方支付 (PayerMax)',
  AIRWALLEX: '第三方支付 (Airwallex)',
};

/** 目录行后台分组（`admin_group` 闭集，70 §3.0）的二级组标题。 */
export const PAYMENT_METHOD_GROUP_TITLE = {
  WALLET: '钱包支付',
  CARD: '银行卡',
  OTHER: '其他',
} as const;

/** 已退役 / 不可选标示（A8 §7.8.8：策略成员与设置行中不在可选列表的取值） */
export const NOT_SELECTABLE_BADGE = '已退役 / 不可选';
